<!--

NOTE:

    There are commented parts because the entrepreneur only has reading access to notes.
    Can not create notes
    Can not filter notes (becasues he only see public notes)
    Can not edit or delete notes 

    update:
    there are variables to control this acctions in deal-page.component.ts. by now:
    CAN_CREATE_NOTES: boolean;
    CAN_CREATE_NOTES_AS_PRIVATE: boolean = false;

-->

<div class="note">
    <div class="note__header position-relative d-flex align-items-center justify-content-between">
        <p class="small mb-0 color-base-50">{{note.updated_at | date: 'd/M/y'}}</p>
        <div class="note__header-menu" *ngIf="isCurrentUserNote">
            <onwac-button 
            (click)="note.toggleMenu()"
            [text]="'FUNNEL.moreOptions' | translate" 
            [type]="'icon'" 
            [icon]="'more_vert'"
            [extra_clases]="'white'"></onwac-button>
            <onwac-dropdown class="right" [menu]="true" 
            [list]="noteMenu"
            [show]="note.showMenu"
            (onChange)="manageNoteMenu($event)"></onwac-dropdown>
        </div>
    </div>
    <div class="note__title" *ngIf="note.title">
        {{note.title}}
    </div>
    <div class="note__content">
        <p class="small">{{note.content}}</p>
    </div>
    <!-- <div class="note__footer">
        <div class="d-flex align-items-center position-relative mt-sm">
            <div class="guard cursor" (click)="managePrivacity()"></div>
            <onwac-switch [active]="!note.internal"></onwac-switch>
            <p class="small mb-0 ml-xs color-base-50"><strong>{{!note.internal ? ('FUNNEL.dealCardNote.public' | translate) : 'FUNNEL.dealCardNote.private' | translate}}</strong> - {{!note.internal ? ('FUNNEL.dealCardNote.publicText' | translate) : 'FUNNEL.dealCardNote.privateText' | translate}}</p>
        </div>
    </div> -->
</div>

<onwac-modal
    [title]="modal.title" 
    [show]="showModal"
    (callback)="getModalResult($event)">
    <div slot="content">
        <p *ngIf="modal.text" class="text-center">{{modal.text}}</p>
        <ng-container *ngIf="noteAction === 'edit'">
            <div class="form-group">
                <onwac-input 
                    [type]="'text'" 
                    [label]="'FUNNEL.dealCardNote.title' | translate" 
                    [input_name]="'dealNoteTitle'"
                    [submitted]="submitted" 
                    [parentForm]="noteForm" 
                    [required]="false" 
                    [validators_feedback]="[
                        {name: 'required', value: 'FUNNEL.dealCardNote.requiredText' | translate}
                    ]"></onwac-input>
            </div>
            <div class="form-group">
                <onwac-input 
                    [type]="'textarea'" 
                    [label]="'FUNNEL.dealCardNote.textareaLabel' | translate" 
                    [input_name]="'dealNote'"
                    [submitted]="submitted" 
                    [parentForm]="noteForm" 
                    [required]="noteRequired" 
                    [validators_feedback]="[
                        {name: 'required', value: 'FUNNEL.dealCardNote.requiredText' | translate}
                    ]"></onwac-input>
            </div>
        </ng-container>
    </div>
    <div slot="footer" class="button-row full-width">
        <ng-container *ngIf="noteAction === 'privacity'">
            <onwac-button (click)="updateNoteInternal(true)" [text]="'MODAL_NOTE.privacity.decline' | translate" [type]="'text'" [extra_clases]="'block'" ></onwac-button>
            <onwac-button (click)="updateNoteInternal(false)" [text]="'MODAL_NOTE.privacity.accept' | translate" [extra_clases]="'block'" ></onwac-button>
        </ng-container>
        <ng-container *ngIf="noteAction === 'delete'">
            <onwac-button (click)="showModal = false" [text]="'MODAL_NOTE.delete.decline' | translate" [type]="'text'" [extra_clases]="'block'" ></onwac-button>
            <onwac-button (click)="deleteNote()" [text]="'MODAL_NOTE.delete.accept' | translate" [extra_clases]="'block'" ></onwac-button>
        </ng-container>
        <ng-container *ngIf="noteAction === 'edit'">
            <onwac-button (click)="showModal = false" [text]="'MODAL_NOTE.edit.decline' | translate" [type]="'text'" [extra_clases]="'block'" ></onwac-button>
            <onwac-button (click)="updateNote()" [text]="'MODAL_NOTE.edit.accept' | translate" [extra_clases]="'block'" ></onwac-button>
        </ng-container>
    </div>
</onwac-modal>